var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"step"},[_c('div',{staticClass:"title"},[_vm._v("换新流程 "),_c('span',[_vm._v("STEP")])]),_c('div',{staticClass:"stepBg"})])
}]

export { render, staticRenderFns }